import React, {Component} from "react";
import {route, routes} from "../../../vars/rd";
import {$shutils} from "../../../libs/snnh/snnh";

/**
 * 카테고리 버튼
 */
class CategoryTheme extends Component {
    /** @var {DaoCategory} */
    model;
    /** @var {function} */
    callback;

    constructor(props) {
        super(props);
        this.closable = props.closable || false;
        this.selectable = props.selectable || false;
        this.model = props.category;
        this.callback = props.onChange;

        this.state = {
            selected: props.selected || false,
        };
    }

    /**
     * 클릭
     */
    changeCategory(event) {
        $shutils.ignoreEvents(event);
        if(!this.selectable && !this.closable) {
            if(!this.state.selected) {
                if(this.callback) this.callback(this.model);
                else route(routes.search_theme, this.model.proid);
            }
        } else {
            if(this.closable) {
                if(this.callback) this.callback(this.model);
            } else {
                const selected = !this.state.selected;
                this.setState(
                    { selected: selected },
                    () => {
                        if(this.callback) this.callback(this.model, selected);
                    }
                );
            }
        }
    }

    /**
     * @param event
     */
    closeCategory(event) {
        $shutils.ignoreEvents(event);
        if(this.callback) this.callback(this.model);
    }

    render() {
        return (
            <li className={`item ${this.state.selected ? 'on' : ''}`}>
                <a onClick={(event) => this.changeCategory(event)}>
                    {
                        ['all', 'best'].indexOf(this.model.proid) === -1 ?
                            <span className={`bullet ${this.model.class}`}></span> :
                            null
                    }
                    {
                        ['best'].indexOf(this.model.proid) === -1 ?
                            <span className="name">{this.model.proname}</span> :
                            <img src={this.model.image} alt={this.model.proname} className="best" />
                    }
                    {
                        this.closable ?
                            <span className="btn-del" onClick={event => this.closeCategory(event)}><img src="/images/icon-del.png" alt="필터삭제"/></span> :
                            null
                    }
                </a>

            </li>
        );
    }
}

export default CategoryTheme;


// WEBPACK FOOTER //
// ./src/pages/components/buttons/category.theme.jsx